import { Helmet } from 'react-helmet'
import MainHeader from '../../../components/MainHeader'
import MainFooter from '../../../components/MainFooter'
import CTAButton from '../../../components/CTAButton.js'
import HorizontalScrollSlider from '../../../components/HorizontalScrollSlider.js'
import BackButton from '../../../components/MainComponents.js'
import { motion } from "framer-motion";

import './ServiceWebdev.css'
import './MServiceWebdev.css'
import { boxvar1, boxvar2, boxvar2_1, boxvar2_2, boxvar2_3, boxvar2dyndelay, boxvar4, oPU } from '../../../core.js'
import { faArrowRight, faChevronRight, faMagnifyingGlassArrowRight } from '@fortawesome/free-solid-svg-icons';

import example_selfcoded from '../../../assets/pictures/sectionimages/example_selfcoded_compressed.webp'
import example_cmswebstudio from '../../../assets/pictures/sectionimages/example_cmswebstudio_compressed.webp'
import example_codecms_combined from '../../../assets/pictures/sectionimages/example_codecms_combined_compressed.webp'


import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

var slides = [
    { img: example_selfcoded, caption: "100% self-coded 👩‍💻", description: "Wir programmieren die Webseite von Grund auf selbst und können so individuellere Konzepte umsetzen. Hier sind wir vollkommen flexibel bei der Umsetzung von Spezialanforderungen und können nahtlos weitere Systeme in die Webseite einbinden.", bg: "var(--ci_color_tilebg)" },
    { img: example_codecms_combined, caption: "Code + Headless CMS ❤️", description: "Die Webseite wird auch 'von Hand' programmiert, beinhaltet aber dynamische Inhalte wie News-Artikel, die du jederzeit selbst über ein Portal anpassen oder ergänzen kannst. Dies bietet die Synergie aus dem Besten von zwei Welten.", bg: "var(--ci_color_primary)" },
    { img: example_cmswebstudio, caption: "CMS-Baukasten 🏗️", description: "Hierbei wird die Webseite über ein sogenanntes Baukasten-System aufgebaut. Das bietet nicht die Flexibilität von self-coded, lässt sich aber dynamischer anpassen. Wir setzen dein Design für dich um und helfen dir bei der Pflege der Inhalte.", bg: "var(--ci_color_tilebg)" },

];

export default function ServiceWebdev() {

    return (
        <div className='mainCon' id='mainCon'>

            <MainHeader selectedsite={"services"} disableanimation={false} />

            <Helmet>
                <meta charSet="utf-8" />
                <title>ToN - Webentwicklung</title>
                <meta property="og:title" content="Webentwicklung on Demand" />
                <meta property="og:description" content="Wir bieten dir ein breites Spektrum an Dienstleistungen, einer unserer Key-Services: Webentwicklung" />
                <meta name="description" content="Wir bieten dir ein breites Spektrum an Dienstleistungen, einer unserer Key-Services: Webentwicklung" />
            </Helmet>
            <section className='sec_next' id='sec_next--service-webdev'>
                <div className='sec_next_cont' id="sec_next--service-webdev--cont" style={{ wordBreak: "break-word" }}>
                    <BackButton href='/services' />


                    <motion.div variants={boxvar2_1} className='about_section_cont' initial="hidden" exit="hidden" whileInView="visible" viewport={{ once: false, margin: "-50px" }}>
                        <br />
                        <h2>Webentwicklung made by ToNetwork</h2>
                        <h3>Jeder hat eine schöne Webseite verdient 🫶</h3>
                        <p>
                            Die Firmenwebseite hat einen enormen Einfluss darauf, wie dein Unternehmen von potentiellen Kunden wahrgenommen bzw. überhaupt erst gefunden wird.<br />
                            Gemeinsam mit dir entwickeln wir eine Konzept, das auf die Designsprache deiner Marke abgestimmt ist und eine hochwertige Außenwirkung erzielt.<br />
                            Dabei gibt es viele Punkte zu beachten, die den entscheidenden Unterschied machen können - doch keine Sorge, wir stehen dir zur Seite!<br />
                        </p>

                    </motion.div>


                    <motion.div variants={boxvar2_1} style={{}} className='' initial="hidden" exit="hidden" whileInView="visible" viewport={{ once: false, margin: "-50px" }}>

                        <h2>Du hast die Wahl.</h2>
                    </motion.div>
                    <motion.div variants={boxvar4} style={{}} className='' initial="hidden" exit="hidden" whileInView="visible" viewport={{ once: false, margin: "-50px" }}>

                        <HorizontalScrollSlider slides={slides} />

                    </motion.div>

                    <motion.div variants={boxvar2_1} style={{}} className='' initial="hidden" exit="hidden" whileInView="visible" viewport={{ once: false, margin: "-50px" }}>
                        <h3>CMS-Baukasten</h3>
                        <p>
                            Für einfache Portfolio-Webseiten bietet sich meist ein CMS-Baukasten an, da hier der Aufwand vergleichsweise gering ist und kein hoher Grad an Komplexität erforderlich ist.<br />
                            Hier bieten wir dir folgende Lösungen an: <a href='https://wordpress.org/' target='_blank'>WordPress</a>, <a href='https://de.wix.com/studio' target='_blank'>WixStudio</a>, <a href='https://webflow.com/' target='_blank>'>Webflow</a>, <a href='https://webstudio.is/' target='_blank>'>Webstudio</a> oder <a href='https://www.framer.com/' target='_blank'>Framer</a>. <br />
                            Die verschiedenen Anbieter unterscheiden sich vor allem im Preis und der späteren Bereitstellung - WordPress selbst ist bspw. kostenlos und eignet sich ideal dafür, die Webseite auf einem eigenen Server zu hosten, während andere auf Cloud-Hosting ausgelegt sind.
                        </p>
                        <p>
                            Das Baukasten System eignet sich auch hervorragend für Online-Shops, da hier rechtliche Anforderungen und Bezahlfunktionen direkt out-of-the-box vorhanden sind.<br />
                            Deinen eigenen Shop setzen wir mit Shopify oder PrestaShop um.<br />
                            Auch hier gibt es wieder verschiedene Vor- und Nachteile der beiden Lösungen, auf die wir in einem persönlichen Beratungsgespräch näher eingehen.
                        </p>
                    </motion.div>

                    <motion.div variants={boxvar2_1} style={{}} className='' initial="hidden" exit="hidden" whileInView="visible" viewport={{ once: false, margin: "-50px" }}>

                        <h3>Self-Coded</h3>
                        <p>
                            Für sehr komplexe Webseiten wie bspw. einer eigenen Online-Plattform wird in fast allen Fällen eine self-coded Lösung benötigt. Hier wird der ganze Code von uns nach deinen Anforderungen selbst entwickelt.<br />
                            Das ist selbstverständlich aufwändiger, bietet aber auch deutlich mehr Anpassungsmöglichkeiten.
                        </p>
                    </motion.div>

                    <motion.div variants={boxvar2_1} style={{}} className='' initial="hidden" exit="hidden" whileInView="visible" viewport={{ once: false, margin: "-50px" }}>

                        <h3>Code + Headless CMS</h3>
                        <p>
                            Du möchtest die High End Funktionalität und gleichzeitig die Flexibilität eines CMS-Systems?<br />
                            Die beiden Varianten lassen sich auch nahtlos miteinander kombinieren.<br />
                            Hier wird der ganze Code von uns nach deinen Anforderungen selbst entwickelt und ein Headless CMS wie Strapi benutzt, um einzelne Elemente der Webseite dynamisch zu laden.<br />
                        </p>
                    </motion.div>

                    <motion.div variants={boxvar2_1} style={{}} className='' initial="hidden" exit="hidden" whileInView="visible" viewport={{ once: false, margin: "-50px" }}>
                        <h3>Und wie macht es ToN?</h3>
                        <p>
                            Unsere eigene Webseite ist 100% self-coded in React und wird ergänzt durch dynamische Inhalte wie News-Artikel oder Banner über das Headless CMS Strapi, was ebenfalls wie die Webseite selbst auf eigenen Servern in Deutschland gehosted wird.
                        </p>
                        <br />
                        <CTAButton className="" showArrow={true} customIcon={null} iconLeft={false} title={"Jetzt beraten lassen"} onclick={() => { oPU('https://calendly.com/tonetworkde-meet/getintouch') }}></CTAButton>

                    </motion.div>

                    <br /><br />

                    <motion.div variants={boxvar2_1} style={{}} className='' initial="hidden" exit="hidden" whileInView="visible" viewport={{ once: false, margin: "-50px" }}>

                        <h2>Unsere Leistungen</h2>
                        <p>
                            Wir decken den Bereich Webentwicklung End-to-End ab, d.h. von der Planung bis hin zur Wartung der Webseite, aber auch der Entwicklung eines individuellen Backends und das Hosting der Webseite.<br />
                            Ob einfaches Online-Portfolio, Online-Shop oder eine eigene Online-Plattform, wir stehen dir bei allen Webprojekten zur Seite.<br />
                            Im Konzeptionsprozess erarbeiten wir gemeinsam mit dir ein vollständiges Corporate Design, falls noch nicht vorhanden und sorgen damit für einen einheitlichen Außenauftritt.
                        </p>
                    </motion.div>

                    <br /><br />

                    <motion.div variants={boxvar2_1} style={{}} className='' initial="hidden" exit="hidden" whileInView="visible" viewport={{ once: false, margin: "-50px" }}>

                        <h2>Warum wir?</h2>
                        <ul>
                            <li>Wir bieten dir einen Rundum-Service, damit du dich entsptannt auf dein Business konzentrieren kannst. Das reicht von Webdesign, AI-Entwicklung bis hin zu Content-Creation.</li>
                            <li>Wir stehen dir auch nach Abschluss des Projekts als langjähriger Partner zur Seite</li>
                            <li>Langjährige Erfahrung in der Softwareentwicklung mit Spezialisierung auf Webentwicklung und Projektmanagement</li>
                            <li>Best Practices = Our Practices. Selbstverständlich nutzen wir branchenübliche Tools wie Git-Versionierung, CI/CD oder Code-Automatisierung</li>
                            <li>Unsere Leistungen sind unabhängig von der Größe deines Projekts</li>

                        </ul>

                    </motion.div>

                    <br /><br /><br /><br />

                    <motion.div variants={boxvar2dyndelay} className='small_services_box small_services_box-bigbottom' initial="hidden" exit="hidden" whileInView="visible" custom={0.3} viewport={{ once: false, margin: "-50px" }}>
                        <div className='small_services_textbox' id="webdev-abo">

                            <h2>Neu: Deine individuelle Webseite als monatliches Abo</h2>
                            <br />
                            <h3>Schon ab 59,99€ monatlich*</h3>
                            <br />
                            <p>
                                Gerade für Startups und kleinere Firmen können die Projektkosten für eine individuell gestaltete Webseite schnell zum Problem werden.<br />
                                <b>Wir verschaffen Abhilfe!</b><br />
                                Bei uns erhältst du ab sofort deine neue Webseite im günstigen Abo ab 59,99€ monatlich*<br />
                                So hast du mehr Geld für andere Investitionen und kannst trotzdem von einer professionellen Webseite profitieren.<br />
                            </p>
                            <br />
                            <CTAButton className="" showArrow={true} customIcon={null} iconLeft={false} title={"Unverbindliches Angebot"} href={'/support'}></CTAButton>

                            <br /><br /><br /><br /><br />
                            <b>Weitere Informationen</b>
                            <br /><br />
                            <details open="">
                                <summary>Wie setzt sich der Preis zusammen?</summary>
                                <p>
                                    Der Preis ist abhängig vom Umfang deiner Ideen und der gewünschten Laufzeit (Mindestlaufzeit 24 Monate) und beginnt bei monatlich 59,99€.<br />
                                    In diesem Preis sind die Kosten für Hosting (standardmäßig 1GB RAM, 1 vCore, bis zu 10Mbit/s), für die Domain und die komplette Softwareentwicklung enthalten.<br />
                                    Die kostenlose Wartung ist auf Störungen beim Hostung begrenzt. Die Wartung und der Support, der sich auf individuelle Funktionen der Software bzw. der Webseite bezieht, ist bis zu 2 Arbeitsstunden je Vertragsjahr inkludiert.<br />
                                    Sofern nicht anderweitig verhandelt, berechnen wir darüber unseren Stundensatz.<br />
                                    Falls du kostenpflichtige Assets - wie Symbolbilder, Musik, Lizenzen etc. - verwenden möchtest, bist du für die Bereitstellung verantwortlich.
                                    Zu Beginn des Projekts berechnen wir eine einmalige vom Abo unabhängige Einrichtungsgebühr von 99€.
                                </p>
                            </details>
                            <br />
                            <details open="">
                                <summary>Was passiert nach Ende der Laufzeit?</summary>
                                <p>
                                    Vor Ende der Vertragslaufzeit hast du die Wahl: Möchtest du die Webseite und das Abo weiterlaufen lassen oder ein neues Abo mit komplett neuem Design abschließen.<br />
                                    So kann deine Webseite immer mit der Zeit gehen, ohne dass du alle paar Jahre viele Tausende Euro auf einmal investieren musst.<br />
                                    <br />
                                    Sobald das Abo endet, enden auch deine Nutzungsrechte an der Webseite (Bilder und sonstige Assets anderer Urheber natürlich ausgeschlossen).<br />
                                    Das Abonnement verlängert sich automatisch um jeweils 6 Monate, sofern nicht anders vereinbart. Die Kündigungsfrist beträgt 3 Monate vor Vertragsende.
                                </p>
                            </details>
                            <br />
                            <details open="">
                                <summary>Wie zahle ich den Betrag?</summary>
                                <p>
                                    Zum Ende des letzten Monats erhältst du von uns die jeweilige Rechnung des kommenden Monats. Überweise dann innerhalb von 14 Tagen den Rechnungsbetrag auf das angegebene Konto unter Angabe der Rechnungsnummer.<br />
                                    Alternativ kannst du auch vorab schon einen Dauerauftrag einrichten. Hierfür gibst du dann bitte die Referenznummer und nicht die Rechnungsnummer aus der Rechnung der Einrichtungsgebühr (oder dem Vorabangebot) an.
                                </p>
                            </details>
                            <br />
                            <details open="">
                                <summary>Was passiert wenn das Hosting nicht mehr ausreicht?</summary>
                                <p>
                                    Wenn die Serverkapazität während der Abolaufzeit ausgereizt wird, hast du die Möglichkeit ein kostenpflichtiges Upgrade durchzuführen.<br />
                                    Die Ressourcen sind strikt limitiert, d.h. bei Überlastung ist die Erreichbarkeit eingeschränkt. In so einem Fall kontaktieren wir dich in Kürze.<br />
                                    Passieren kann das, wenn bspw. plötzlich deutlich mehr Besucher auf deine Webseite gelangen.<br />
                                    Möglicherweise muss dann in Abstimmung ein Umzug zu einem externen Hostinganbieter erfolgen.
                                </p>
                            </details>
                            <br />
                            <details open="">
                                <summary>Sind Änderungen an der Webseite während der Laufzeit möglich?</summary>
                                <p>
                                    Ja, jedoch verrechnen wir für Änderungen, die die einmaligen zumutbaren Rechtschreibkorrekturen übersteigen, unseren üblichen Stundensatz, sofern nicht anders verhandelt. Eine Verrechnung mit dem Abopreis ist dabei nicht möglich.<br />
                                    Als Anhaltspunkt folgendes Beispiel:<br />
                                    Wenn du während der Laufzeit einmal dein Logo ausgetauscht haben möchtest oder die Öffnungszeiten auf der Kontaktseite angepasst werden müssen, ist das kein Thema. Möchtest du aber einen ganzen Absatz neu haben, ist das ein Mehraufwand, den wir verrechnen.
                                    Kontaktiere uns einfach ganz unverbindlich, wenn du etwas geändert haben möchtest, und wir erarbeiten gemeinsam eine Win-Win-Lösung.
                                </p>
                            </details>
                            <br />

                            <br /><br />
                            * Hinweis: Alle Preise exkl. MwSt.
                            <br /><br />
                            <a href='/ToNetwork-Webabo-AGB-Jan24.pdf' target='_blank'>Download der Webabo-AGB</a>

                        </div>
                    </motion.div>

                    <br /><br /><br /><br />


                    <motion.div variants={boxvar2_1} style={{}} className='' initial="hidden" exit="hidden" whileInView="visible" viewport={{ once: false, margin: "-50px" }}>
                        <h2>Was kostet das?</h2>
                        <p>
                            Eine transparente Preisübersicht findest du auf unserer Preise-Seite. Alle dort genannten Beträge sind <b>Listenpreise ohne Rabatte</b> und werden individuell auf dein Projekt zugeschnitten.
                        </p>
                        <br />
                        <CTAButton className="" showArrow={true} customIcon={null} iconLeft={false} title={"Zu den Preisen"} href={'/pricing'}></CTAButton>
                    </motion.div>

                    <br /><br /><br /><br />

                    <motion.div variants={boxvar2dyndelay} className='small_services_box small_services_box-bigbottom' initial="hidden" exit="hidden" whileInView="visible" custom={0.3} viewport={{ once: false, margin: "-50px" }}>
                        <div className='small_services_textbox'>
                            <h3>&lt;Individuelle Entwicklung und Beratung/&gt;</h3>
                            <br /><br />
                            <p>
                                Du bist bei unseren Leistungen nicht fündig geworden? Wir sind offen für Herausforderungen 😉<br />
                                Wir stehen dir mit Expertise zur Seite und entwickeln bspw. ein Branding für deine Marke, eine Elektronikkomponente oder eine individuelle Softwarelösung für dich.
                            </p>
                            <CTAButton className="" showArrow={true} customIcon={null} iconLeft={false} title={"Jetzt anfragen"} href={'/support'}></CTAButton>
                        </div>
                    </motion.div>

                    <br /><br /><br /><br />
                </div>
            </section >

            <MainFooter />
        </div >
    )
}